import React, { useRef } from 'react'
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, EffectCoverflow } from 'swiper/modules';
import MediaConverter from './conVerter';
import ProcessAnimation from './processAn';
import ChatInterface from './aiChat';


import 'swiper/css/navigation';
// import Logo from './Logo';
function Slider() {
    const { language } = useLanguage();
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const swiperRef = useRef(null);

    const handlePrevClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (swiperRef.current) {
            swiperRef.current.slidePrev();
        }
    };

    const handleNextClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (swiperRef.current) {
            swiperRef.current.slideNext();
        }
    };

    return (
        <Swiper 
            style={{ marginTop: '3rem' }} 
            data-animate="blur" 
            modules={[EffectCoverflow, Navigation]}
            onSwiper={(swiper) => { swiperRef.current = swiper; }}
            effect="coverflow"
            centeredSlides={true}
            slidesPerView={1}
            grabCursor={true}
            breakpoints={{
                640: {
                    slidesPerView: 1.5,
                },
            }}
            navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
            }}
            onBeforeInit={(swiper) => {
                if (typeof swiper.params.navigation !== 'boolean') {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                }
            }}
            className="swiper-features">
            <SwiperSlide>
                <ProcessAnimation />
            </SwiperSlide>
            <SwiperSlide>
                <MediaConverter />
            </SwiperSlide>
            <SwiperSlide>
                <ChatInterface />
            </SwiperSlide>

     

            <div className="slider_actions u-vflex-center-center u-mt-5">
                <div className="u-display-contents"><div className="u-btn-group">
                    <div className="btn_swiper_wrap is-prev" 
                         style={{ cursor: 'pointer' }} 
                         ref={prevRef}
                         onClick={handlePrevClick}
                         onTouchEnd={handlePrevClick}>
                        <div className="g_clickable_wrap">
                            <span target="_blank" rel="noopener noreferrer" href="" className="g_clickable_link w-inline-block">
                                <span className="g_clickable_text u-sr-only">{language === 'ar' ? 'شاهد العرض التوضيحي' : 'View Demo'}</span>
                            </span>
                            <button type="button" className="g_clickable_btn">
                                <span className="g_clickable_text u-sr-only">{language === 'ar' ? 'شاهد العرض التوضيحي' : 'View Demo'}</span></button></div>
                        <div className="btn_primary_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 20 20" fill="none" className="g_svg">
                                <path d="M15.8333 9.99984H4.16663M4.16663 9.99984L9.99996 15.8332M4.16663 9.99984L9.99996 4.1665" stroke="currentColor">
                                </path>
                            </svg>
                        </div>
                    </div>
                    <div data-wf--btn-primary--style="base" className="btn_primary_wrap">
                        <div className="g_clickable_wrap">
                            <Link to={`/${language}/watch-demo`} className="g_clickable_link w-inline-block">
                                <span className="g_clickable_text u-sr-only">{language === 'ar' ? 'شاهد العرض التوضيحي' : 'View Demo'}</span>
                            </Link>
                            <button type="button" className="g_clickable_btn">
                                <span className="g_clickable_text u-sr-only">{language === 'ar' ? 'شاهد العرض التوضيحي' : 'View Demo'}</span>
                            </button>
                        </div>
                        <div aria-hidden="true" className="btn_primary_text u-weight-medium u-text-style-main">
                            {language === 'ar' ? 'شاهد العرض التوضيحي' : 'View Demo'}
                        </div>
                        <div className="btn_primary_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 24 24" fill="none" className="g_svg">
                                <circle cx="12" cy="12" r="11.5" stroke="currentColor"></circle>
                                <path d="M7.11114 12L16.8889 12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M13.3334 15.5556L16.8889 12L13.3334 8.44446" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </div>
                    </div>
                    <div className="btn_swiper_wrap is-next" 
                         style={{ cursor: 'pointer' }} 
                         ref={nextRef}
                         onClick={handleNextClick}
                         onTouchEnd={handleNextClick}>
                        <div className="g_clickable_wrap">
                            <span target="" href="" className="g_clickable_link w-inline-block">
                                <span className="g_clickable_text u-sr-only">{language === 'ar' ? 'شاهد العرض التوضيحي' : 'View Demo'}</span>
                            </span>
                            <button type="button" className="g_clickable_btn">
                                <span className="g_clickable_text u-sr-only">{language === 'ar' ? 'شاهد العرض التوضيحي' : 'View Demo'}</span>
                            </button>
                        </div>
                        <div className="btn_primary_icon is-flipped">
                            <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 20 20" fill="none" className="g_svg">
                                <path d="M15.8333 9.99984H4.16663M4.16663 9.99984L9.99996 15.8332M4.16663 9.99984L9.99996 4.1665" stroke="currentColor"></path>
                            </svg>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </Swiper>
    )
}
export default Slider